<template>
    <div class="recommend-teacher-box">
        <div class="teacher-list-box">
            <div class="teacher-item" v-for="(item, index) in teacherList" :key="index" @click="gotoDetail(item.id)">
                <div class="teacher-item-content">
                    
                    <div class="avatar">
                        <img :src="item.photo" />
                        <div class="name-box">
                            <div class="name">{{ item.realname }}</div>
                            <div class="adress">{{ item.address }}</div>
                        </div>
                    </div>
                    <!-- <div class="middle-star">
                        <img :src="require('@/assets/icon/star.png')" />
                        <span>{{ item.avgscore }}</span>
                        <span class="reviews"> (27 Reviews)</span>
                        <img :src="require('@/assets/icon/userlevel.png')" />
                        <span>lv{{ item.userlevel }}</span>
                    </div> -->
                    <div class="describe">
                        {{ item.desc }}
                    </div>
                    <div class="price">
                        <span>Price:</span>
                        <span>C$21/h</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "recommend-teachers",
    components: {},
    props:['teacherList'],
    data() {
        return {
            // teacherList: [],
        };
    },
    created() {
        // this.getRecommendTeachers();
    },
    methods: {
        gotoDetail(teacherId){
            this.$router.push({path:'/page/teacher',query:{teacherId:teacherId}})
        },
    },
};
</script>

<style scoped lang="scss">
@import "~@/utils/vw.scss";
.recommend-teacher-box {
    height: calc(100vh - vw(96));
    .title-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-wrap: nowrap;
        .main-title {
            width: auto;
            font-weight: 500;
            font-size: vw(36);
            span:nth-child(1) {
                color: #0a033c;
                -webkit-text-stroke: 1px #0a033c;
            }
            span:nth-child(2) {
                color: #f48c06;
                -webkit-text-stroke: 1px #f48c06;
            }
        }
        .sub-title {
            width: vw(560);
            margin-top: vw(16);
            color: #696984;
            line-height: vw(40);
            font-size: vw(24);
            text-align: center;
        }
    }
    .teacher-list-box {
        margin-top: vw(32);
        padding: 0 vw(112);
        display: flex;
        flex-wrap: wrap;
        .teacher-item {
            width: 25%;
        }
        .teacher-item {
            .teacher-item-content{
                margin: vw(16);
                padding: vw(16) vw(16) vw(24) vw(16);
                box-sizing: border-box;
                background: #fff;
                border-radius: 24px;
                box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
            }
            cursor: pointer;
            .avatar {
                position: relative;
                width: 100%;
                height: auto;
                img {
                    width: 100%;
                    height: 380px;
                    border-radius: 16px;
                }
                .name-box {
                    position: absolute;
                    bottom: 12px;
                    left: 17px;
                    color: #ffffff;
                    font-weight: 600;
                    line-height: vw(24);
                    .name {
                        font-size: vw(24);
                    }
                    .adress {
                        font-size: 16px;
                    }
                }
            }
            .middle-star {
                margin-top: vw(16);
                display: flex;
                align-items: center;
                font-size: vw(16);
                line-height: vw(22);
                font-weight: 500;
                img {
                    margin-right: 8px;
                }
                .reviews {
                    color: #a6a6a6;
                    margin-right: 16px;
                }
            }
            .describe {
                min-height: vw(48);
                margin-top: vw(16);
                line-height: vw(24);
                font-size: vw(16);
                color: #0a033c;
                
                overflow-y: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .price {
                margin-top: vw(16);
                line-height: 24px;
                color: #696984;
                font-size: vw(16);
                span:nth-child(2) {
                    margin-left: 8px;
                    color: #f48c06;
                }
            }
        }
    }
}
</style>